<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
            <b-row>
                <b-overlay :show="formLoader">
                    <b-col lg="12" sm="12">
                        <ValidationObserver ref="form" v-slot="{ handleSubmit, reset }">
                        <b-form  @submit.prevent="handleSubmit(addTmp)" @reset.prevent="reset" enctype="multipart/form-data">
                            <b-row>
                                <b-col lg="6" sm="6">
                                    <ValidationProvider name="Service Type" vid="service_type_id" rules="required|min_value:1">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="service_type_id"
                                            slot-scope="{ valid, errors }"
                                        >
                                        <template v-slot:label>
                                            {{$t('grant_config.service_type')}}<span class="text-danger">*</span>
                                            </template>
                                        <b-form-select
                                            plain
                                            :disabled = "id ? true : false"
                                            v-model="formData.service_type_id"
                                            :options="serviceTypeList"
                                            @change="serviceName"
                                            id="service_type_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" sm="6">
                                    <ValidationProvider name="Service Name" vid="service_name_id" rules="required|min_value:1">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="service_name_id "
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                            {{$t('grant_config.service_name')}} <span class="text-danger">*</span>
                                            </template>
                                                <b-overlay :show="minLoader">
                                                    <b-form-select
                                                    plain
                                                    :disabled = "id ? true : false"
                                                    v-model="formData.service_name_id"
                                                    id="service_name_id"
                                                    :options="serviceNameList"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                </b-overlay>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                            </b-row>
                            <hr>
                            <b-row>
                                <b-col lg="6" sm="6">
                                    <ValidationProvider name="Title (En)" vid="eligibilities_en_id">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="eligibilities_en_id"
                                            slot-scope="{ valid, errors }"
                                        >
                                        <template v-slot:label>
                                            {{$t('socialWelfareMcm.eligibilitiesEn')}}<span class="text-danger">*</span>
                                            </template>
                                        <b-form-input
                                            plain
                                            v-model="detailsFormData.eligibilities"
                                            id="eligibilities_en_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            </b-form-input>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" sm="6">
                                    <ValidationProvider name="Title (Bn)" vid="eligibilities_bn_id">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="eligibilities_bn_id"
                                            slot-scope="{ valid, errors }"
                                        >
                                        <template v-slot:label>
                                            {{$t('socialWelfareMcm.eligibilitiesBn')}}<span class="text-danger">*</span>
                                        </template>
                                        <b-form-input
                                            plain
                                            v-model="detailsFormData.eligibilities_bn"
                                            id="title_bn_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            </b-form-input>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                            </b-row>
                            <div class="row">
                                <div class="col-sm-3"></div>
                                <div class="col text-right">
                                    <b-button type="submit" variant="primary" class="mr-2">{{ $t('institute_manangement.add') }}</b-button>
                                </div>
                            </div>
                        </b-form>
                        </ValidationObserver>
                        <ValidationObserver ref="form1"  v-slot="{ handleSubmit, reset }">
                            <b-form @submit.prevent="handleSubmit(saveData)" @reset.prevent="reset" enctype="multipart/form-data">
                                <br/>
                                <b-row>
                                    <b-table-simple  bordered>
                                        <thead>
                                            <tr class="bg-primary">
                                                <th scope="col">{{ $t('globalTrans.sl_no') }}</th>
                                                <th scope="col">{{ $t('socialWelfareMcm.eligibilitiesEn') }}</th>
                                                <th scope="col">{{ $t('socialWelfareMcm.eligibilitiesBn') }}</th>
                                                <th scope="col" class="text-center">{{ $t('globalTrans.action') }}</th>
                                            </tr>
                                        </thead>
                                        <b-tbody>
                                            <b-tr v-for="(item, index) in formData.details" :key="index">
                                                <b-td>
                                                    {{ $n(index + 1) }}
                                                </b-td>
                                                <b-td>
                                                    <ValidationProvider name="Title (En)" vid="eligibilities" rules="required">
                                                        <b-form-group
                                                            slot-scope="{ valid, errors }"
                                                            >
                                                            <b-form-input
                                                            v-model="item.eligibilities"
                                                            id="eligibilities"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                            </b-form-input>
                                                            <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-td>
                                                <b-td>
                                                    <ValidationProvider name="Title (Bn)" vid="instructor_id" rules="required">
                                                        <b-form-group
                                                            slot-scope="{ valid, errors }"
                                                            >
                                                            <b-form-input
                                                            v-model="item.eligibilities_bn"
                                                            id="eligibilities_bn"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                            </b-form-input>
                                                            <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-td>
                                                <b-td>
                                                    <b-button type="button" :title="$t('globalTrans.delete')" @click="remove(index)" class="btn btn- iq-bg-danger btn-sm text-center ml-1"><i class="ri-delete-bin-line m-0"></i></b-button>
                                                </b-td>
                                            </b-tr>
                                        </b-tbody>
                                    </b-table-simple>
                                </b-row>
                                <div class="row">
                                    <div class="col-sm-3"></div>
                                    <div class="col text-right">
                                        <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                                        &nbsp;
                                        <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-3')">{{ $t('globalTrans.cancel') }}</b-button>
                                    </div>
                                </div>
                            </b-form>
                        </ValidationObserver>
                    </b-col>
                </b-overlay>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { socialWelfareServiceBaseUrl } from '@/config/api_config'
import { serviceEligibilityStoreApi, serviceEligibilityUpdateApi, getServiceNames } from '../../api/routes'

export default {
  props: ['id'],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  created () {
    if (this.id) {
        this.getServiceNameList()
        const formData1 = this.$store.state.list.find(item => item.id === this.id)
        this.formData.service_type_id = formData1.service_type_id
        this.formData.service_name_id = formData1.service_name_id
        this.formData.details = JSON.parse(formData1.eligibilities)
    }
  },
  mounted () {
    core.index()
  },
  data () {
    return {
      saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
      perShowData: 0,
      showData: 0,
      detailsFormData: {
        eligibilities: '',
        eligibilities_bn: ''
      },
      formData: {
        service_type_id: 0,
        service_name_id: 0,
        details: []
      },
      details1: [],
      getServiceName: [],
      serviceNameList: [],
      serviceList: [],
      edit_upload_check: 0,
      count: 0,
      url: socialWelfareServiceBaseUrl,
      formLoader: false,
      minLoader: false
    }
  },
  computed: {
    serviceTypeList: function () {
        const objectData = this.$store.state.SocialWelfareService.commonObj.serviceTypeList.filter(item => item.status === 1)
        return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    currentLocale () {
        return this.$i18n.locale
    }
  },
  methods: {
    serviceName () {
        this.minLoader = true
        const params = Object.assign({}, this.search, { service_type_id: this.formData.service_type_id })
        RestApi.getData(socialWelfareServiceBaseUrl, getServiceNames, params).then(response => {
            if (response.success) {
                this.minLoader = false
                this.serviceNameList = response.data.map((obj, key) => {
                    if (this.$i18n.locale === 'bn') {
                        return { value: obj.id, text: obj.service_name_bn }
                    } else {
                        return { value: obj.id, text: obj.service_name }
                    }
                })
            }
        })
    },
    getServiceNameList () {
        const objectData = this.$store.state.SocialWelfareService.commonObj.serviceNameList.filter(item => item.status === 1)
       this.serviceNameList = objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    addTmp () {
        this.formData.details.push(JSON.parse(JSON.stringify(this.detailsFormData)))
        this.detailsFormData.eligibilities = ''
        this.detailsFormData.eligibilities_bn = ''
        this.$nextTick(() => {
            this.$refs.form.reset()
        })
    },
     remove (index) {
        this.formData.details.splice(index, 1)
    },
    async saveData () {
        this.formLoader = true
        const loadingState = { loading: false, listReload: false }
        let result = null
        if (this.id) {
        result = await RestApi.putData(socialWelfareServiceBaseUrl, `${serviceEligibilityUpdateApi}/${this.id}`, this.formData)
        } else {
        result = await RestApi.postData(socialWelfareServiceBaseUrl, serviceEligibilityStoreApi, this.formData)
        }
        loadingState.listReload = true
        this.$store.dispatch('mutateCommonProperties', loadingState)
        if (result.success) {
            this.formLoader = false
            this.$toast.success({
                title: this.$t('globalTrans.success'),
                message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                color: '#D6E09B'
            })
            this.$bvModal.hide('modal-3')
        } else {
            this.formLoader = false
            this.$refs.form.setErrors(result.errors)
            this.$toast.error({
                title: 'Error',
                message: 'Operation failed! Service Type already exist.'
            })
        }
    }
  }
}
</script>
